import { render, staticRenderFns } from "./bffLine.vue?vue&type=template&id=4c33e7a0&scoped=true&"
import script from "./bffLine.vue?vue&type=script&lang=ts&"
export * from "./bffLine.vue?vue&type=script&lang=ts&"
import style0 from "./bffLine.vue?vue&type=style&index=0&id=4c33e7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c33e7a0",
  null
  
)

export default component.exports